import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ToolboxIcon from './icons/ToolboxIcon';

const messages = defineMessages({
  play: {
    id: 'PlayPauseAudioButton.label.play',
    defaultMessage: 'Play',
  },
  pause: {
    id: 'PlayPauseAudioButton.label.pause',
    defaultMessage: 'Pause',
  },
  errorPlay: {
    id: 'PlayPauseAudioButton.label.errorPlay',
    defaultMessage: 'Error',
  },
});

class PlayPauseAudioButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: true,
      error: false,
    };
    this.audioPlayer = React.createRef();
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.filename !== prevProps.filename) {
      this.setState({
        isPlaying: true,
      });
    }
  }

  handleError = () => {
    this.setState({ error: true });
  };

  onPlay = () => {
    this.setState({
      ...this.state,
      isPlaying: false,
    });
  };

  onPause = () => {
    this.setState({
      ...this.state,
      isPlaying: true,
    });
  };

  render() {
    const {
      filename,
      id,
      intl: { formatMessage },
    } = this.props;
    const { isPlaying, error } = this.state;

    return !error ? (
      <>
        <audio
          src={filename}
          id={`audioPlayer${id}`}
          onPlay={this.onPlay}
          onPause={this.onPause}
          ref={this.audioPlayer}
          onError={(e) => {
            this.handleError(e);
          }}
        >
          <track kind="captions" label="captions" />
        </audio>
        {isPlaying && (
          <span onClick={() => this.audioPlayer.current.play()}>
            <ToolboxIcon name="control-play-filled" className="p-2">
              {formatMessage(messages.play)}
            </ToolboxIcon>
          </span>
        )}
        {!isPlaying && (
          <span
            onClick={() => {
              this.audioPlayer.current.pause();
              this.audioPlayer.current.currentTime = 0;
            }}
          >
            <ToolboxIcon name="control-stop-filled" className="p-2">
              {formatMessage(messages.pause)}
            </ToolboxIcon>
          </span>
        )}
      </>
    ) : (
      ''
    );
  }
}

export default injectIntl(PlayPauseAudioButton);
